export const DefaultListParams = {
    pagination: { page: 0, perPage: 1000 },
    filter: {},
    sort: { field: "id", order: "ASC" },
};
